export enum DealCostType {
  LEGAL = 'LEGAL',
  DUE_DILIGENCE = 'DUE_DILIGENCE',
  TRANSACTION = 'TRANSACTION',
}

export const DEAL_COST_TYPE_LABELS: Record<DealCostType, string> = {
  [DealCostType.LEGAL]: 'Legal',
  [DealCostType.DUE_DILIGENCE]: 'Due Diligence',
  [DealCostType.TRANSACTION]: 'Transaction',
};

/**
 * CLOSED costs belong to a posted investment; PENDING ones wait for the deal
 * to close or break; ABORTED ones are a broken deal.
 */
export type DealCostOutcome = 'CLOSED' | 'PENDING' | 'ABORTED';

export const DEAL_COST_OUTCOME_LABELS: Record<DealCostOutcome, string> = {
  CLOSED: 'Deal closed',
  PENDING: 'Deal not yet closed',
  ABORTED: 'Deal did not close',
};

export interface DealCost {
  id: string;
  fund_id: string;
  outcome: DealCostOutcome;
  portfolio_company_id: string | null;
  portfolio_company_name: string | null;
  investment_fund_transaction_id: string | null;
  deal_name: string | null;
  cost_type: DealCostType;
  description: string | null;
  amount: number;
  cost_date: string;
  created_at: string;
  updated_at: string;
}

interface DealCostFromBankLineBase {
  cost_type: DealCostType;
  description: string | null;
}

export type DealCostFromBankLineCreate =
  | (DealCostFromBankLineBase & {
      outcome: 'CLOSED';
      investment_fund_transaction_id: string;
    })
  | (DealCostFromBankLineBase & {
      outcome: 'PENDING' | 'ABORTED';
      deal_name: string;
    });

/** How a pending deal cost is resolved: the deal closed or broke. */
export type DealCostResolve =
  | { outcome: 'CLOSED'; investment_fund_transaction_id: string }
  | { outcome: 'ABORTED'; aborted_on: string };

export interface DealCostUpdate {
  cost_type?: DealCostType;
  description?: string | null;
}

/** A posted investment fund transaction a deal cost can be booked against. */
export interface DealCostInvestment {
  id: string;
  portfolio_company_id: string;
  portfolio_company_name: string;
  transaction_type: string;
  transaction_date: string;
  description: string | null;
  amount: number;
  currency: string;
}

export interface DealCostPage {
  items: DealCost[];
  total_count: number;
  page: number;
  page_size: number;
}

export interface DealCostsSummary {
  total_costs: number;
  cost_count: number;
}
